export class WarehouseBankLineApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getLines(warehouseBankId) {
    return this.#http.get(`/api/warehouse-banks/${warehouseBankId}/lines`);
  }

  async getLine({ warehouseBankId, lineId }) {
    return this.#http.get(`/api/warehouse-banks/${warehouseBankId}/lines/${lineId}`);
  }

  async createLine({ warehouseBankId, ...body }) {
    return this.#http.post(`/api/warehouse-banks/${warehouseBankId}/lines`, body);
  }

  async updateLine({ warehouseBankId, lineId, ...body }) {
    return this.#http.put(`/api/warehouse-banks/${warehouseBankId}/lines/${lineId}`, body);
  }

  async deleteLine({ warehouseBankId, lineId }) {
    return this.#http.delete(`/api/warehouse-banks/${warehouseBankId}/lines/${lineId}`);
  }

  async manageEligibilities({ warehouseBankId, lineId, eligibilities }) {
    return this.#http.put(
      `/api/warehouse-banks/${warehouseBankId}/lines/${lineId}/eligibilities`,
      eligibilities,
    );
  }

  async getSummaryMetrics() {
    return this.#http.get('/api/warehouse-summary/metrics');
  }

  async getRateHistory({ warehouseBankId, lineId, fromDate, toDate }) {
    const params = {};

    if (fromDate) {
      params.fromDate = fromDate;
    }

    if (toDate) {
      params.toDate = toDate;
    }

    return this.#http.get(`/api/warehouse-banks/${warehouseBankId}/lines/${lineId}/rate-history`, {
      params,
    });
  }
}
